<template>
  <div class="grid justify-items-center" id="app">
    <form action="/register/salva" method="POST" class="form-login">
      <input type="hidden" :value="csrfToken" name="_token" />
      <div class="login-form">
        <InputText id="email" name="email" type="email" class="form-control"
                   v-model="email" required autocomplete="email"
                   autofocus placeholder="Email" />
      </div>
      <div class="login-form">
        <InputText id="password" name="password" type="password" class="form-control"
                   v-model="password" required
                   autofocus placeholder="Password" />
      </div>
      <div class="login-form">
        <button type="submit" class="btn btn-primary">
          Register
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';

export default {
  components: {
    InputText,
    Password
  },
  data() {
    return {
      email: '',
      password: '',
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    };
  },
  methods: {
    handleSubmit() {
      console.log(this.email + " " + this.password);
    },
  }

}
</script>

<style scoped>

</style>